import axios from "axios";
import { BASE_URL } from "./config";
import { getActiveOutletId } from "../utils/helpers/outletContext";
import { getReadableApiError } from "../utils/helpers/apiError";

const stripDuplicateBaseUrl = (url, baseURL) => {
  if (!url || typeof url !== "string") return url;
  const prefixes = [baseURL, BASE_URL].filter((p) => p && p !== "/");
  for (const prefix of prefixes) {
    if (url.startsWith(prefix)) {
      const stripped = url.slice(prefix.length);
      return stripped.startsWith("/") ? stripped : `/${stripped}`;
    }
    const trimmedPrefix = prefix.replace(/^\/+/, "");
    if (trimmedPrefix && url.startsWith(trimmedPrefix)) {
      const stripped = url.slice(trimmedPrefix.length);
      return stripped.startsWith("/") ? stripped : `/${stripped}`;
    }
  }
  return url;
};

const authorizedAxios = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: "application/json",
    "X-Requested-With": "XMLHttpRequest",
  },
});

authorizedAxios.interceptors.request.use(
  (config) => {
    if (config.url) {
      config.url = stripDuplicateBaseUrl(config.url, config.baseURL);
    }
    try {
      const stored = localStorage.getItem("auth");
      const token = stored ? JSON.parse(stored)?.access_token : null;

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      const outletId = getActiveOutletId();
      if (outletId) {
        config.headers["X-Outlet-Id"] = String(outletId);
      }
    } catch (e) {
      console.warn("Gagal parsing token dari localStorage:", e);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

authorizedAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    const readableMessage = getReadableApiError(error, "Permintaan belum dapat diproses. Silakan coba kembali.");
    error.userMessage = readableMessage;
    if (Object.prototype.toString.call(error?.response?.data) === "[object Object]") {
      error.response.data = {
        ...error.response.data,
        original_message: error.response.data.message,
        message: readableMessage,
      };
    }

    if (error?.response?.status === 401) {
      localStorage.removeItem("auth");
      localStorage.removeItem("userProfile");
      localStorage.removeItem("akas_active_outlet_id");
      localStorage.removeItem("akas_active_outlet");

      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }

    return Promise.reject(error);
  },
);

export default authorizedAxios;
